import CustomModal from "../../../components/customModal/CustomModal";
import { Form, Button } from "react-bootstrap";
import * as Yup from "yup";
import { FormikHelpers, useFormik } from "formik";
import { handleQuantityInput } from "../../../utils/commonUtils";

interface EditOrderItemModalProps {
  showModal: boolean;
  toggleModal: () => void;
  orderItem: any;
  onUpdate: (values: any) => void;
}

export const EditOrderItemModal = ({
  showModal,
  toggleModal,
  orderItem,
  onUpdate,
}: EditOrderItemModalProps) => {
  const initialVal = {
    orderQty: orderItem?.orderQty ?? 0,
    rate: orderItem?.ratePerPurchaseUOM ?? 0,
  };

  const { handleChange, values, handleSubmit, touched, errors } = useFormik({
    initialValues: initialVal,
    validationSchema: Yup.object({
      orderQty: Yup.number()
        .required("Order Qty is Required")
        .min(0, "Order Qty must be greater than or equal to 0"),
      rate: Yup.number()
        .required("Rate is Required")
        .min(0, "Rate must be greater than or equal to 0"),
    }),
    onSubmit: async (values: any, { setSubmitting }: FormikHelpers<any>) => {
      try {
        const payload = {
          ...orderItem,
          orderQty: values.orderQty,
          rate: values.rate,
        };
        onUpdate(payload);
      } catch (err: any) {}
      setSubmitting(false);
    },
    enableReinitialize: true,
  });

  const handleQtyInput = (e: React.FormEvent<HTMLInputElement>) => {
    handleQuantityInput(e, 4, 10);
  };

  if (!showModal) return null;

  return (
    <CustomModal
      title="Edit Order Item"
      id="editOrderItemModal"
      content={
        <div className="modal--content--wrapper">
          <div className="modal--inputbox">
            <Form onSubmit={handleSubmit}>
              <div className="edit-order-item-info">
                <div className="info-row">
                  <div className="info-item">
                    <label>Order No:</label>
                    <span>{orderItem?.refNo ?? "-"}</span>
                  </div>
                  <div className="info-item">
                    <label>Product No:</label>
                    <span>{orderItem?.productNo ?? "-"}</span>
                  </div>
                  <div className="info-item">
                    <label>Description:</label>
                    <span>{orderItem?.productDescription ?? "-"}</span>
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-item">
                    <label>Location:</label>
                    <span>{orderItem?.locationName ?? "-"}</span>
                  </div>
                  <div className="info-item">
                    <label>Reorder Level:</label>
                    <span>{orderItem?.reorderLevel ?? "-"}</span>
                  </div>
                  <div className="info-item">
                    <label>Qty on Hand:</label>
                    <span>{orderItem?.qtyOnHand ?? "-"}</span>
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-item">
                    <label>Order Qty (Purchase UOM):</label>
                    <span>{orderItem?.orderQtyPurchaseUOM ?? "-"}</span>
                  </div>
                  <div className="info-item">
                    <label>Purchase UOM:</label>
                    <span>{orderItem?.purchaseUOM ?? "-"}</span>
                  </div>
                  <div className="info-item">
                    <label>Status:</label>
                    <span>{orderItem?.status ?? "-"}</span>
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-item">
                    <label>Vendor Name:</label>
                    <span>{orderItem?.vendorName ?? "-"}</span>
                  </div>
                </div>
              </div>

              <div className="edit-order-item-fields">
                <div className="fields-row">
                  <Form.Group className="field-item">
                    <Form.Label>Order Qty</Form.Label>
                    <div className="input-with-unit">
                      <Form.Control
                        min={0}
                        type="text"
                        inputMode="decimal"
                        placeholder="Enter Order Qty"
                        isInvalid={touched.orderQty && !!errors.orderQty}
                        id="orderQty"
                        name="orderQty"
                        onChange={handleChange}
                        onInput={handleQtyInput}
                        value={values.orderQty}
                      />
                      {orderItem?.unitName && (
                        <span className="unit-label">{orderItem.unitName}</span>
                      )}
                    </div>
                    {touched.orderQty && errors.orderQty ? (
                      <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                        {errors.orderQty as string}
                      </Form.Control.Feedback>
                    ) : null}
                  </Form.Group>

                  <Form.Group className="field-item">
                    <Form.Label>Rate</Form.Label>
                    <Form.Control
                      min={0}
                      type="text"
                      inputMode="decimal"
                      placeholder="Enter Rate"
                      isInvalid={touched.rate && !!errors.rate}
                      id="rate"
                      name="rate"
                      onChange={handleChange}
                      onInput={handleQtyInput}
                      value={values.rate}
                    />
                    {touched.rate && errors.rate ? (
                      <Form.Control.Feedback type="invalid">
                        {errors.rate as string}
                      </Form.Control.Feedback>
                    ) : null}
                  </Form.Group>
                </div>
              </div>

              <Form.Group className="full-width text-end">
                <Button
                  onClick={toggleModal}
                  style={{ marginRight: "10px" }}
                  variant="outline-primary"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  onClick={handleSubmit as any}
                >
                  Save
                </Button>
              </Form.Group>
            </Form>
          </div>
        </div>
      }
      onClose={toggleModal}
    />
  );
};
